import { useMutation, useQuery } from "@apollo/client";
import { LocationGenerics } from "router/location";
import { AssignInstallationServiceOrderForm } from "components/forms";
import { Modal } from "components/layouts";
import { useFormik } from "formik";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { ASSIGN_SERVICE_ORDER, GET_SERVICE_ORDER } from "./apollo";

export default function AssignInstallationServiceOrderContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_SERVICE_ORDER, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
  });
  const [assignServiceOrder] = useMutation(ASSIGN_SERVICE_ORDER);

  const form = useFormik({
    initialValues: {
      assigneeInfo: {
        assigneeType: "FieldAgent" as
          | "FieldAgent"
          | "FarmingOutContractor"
          | "MeterManufacturingContractor",
        assignee: null as any,
      },
      meterInfo: {
        meter: null as any,
      },
      extraInfo: {
        estimatedResolutionDate: "",
        priority:
          data?.serviceOrder?.category === "Premium"
            ? "Low"
            : data?.serviceOrder?.category === "Express"
              ? "Medium"
              : "Low",
        notes: "",
      },
    },
    onSubmit: async (values) => {
      await assignServiceOrder({
        variables: {
          id: searchParams.id,
          assignee: values.assigneeInfo?.assignee?._id,
          assigneeType: values.assigneeInfo.assigneeType,
          installationMeter: values.meterInfo?.meter?._id,
          ...values.extraInfo,
        },
      }).then(({ data }) => {
        if (data.assignServiceOrder._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Service Order Assigned Successfully",
            })
          );
          form.resetForm();
          refetch?.();
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not assign Service Order",
            })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  useEffect(() => {
    form.setValues({
      assigneeInfo: {
        assigneeType: data?.serviceOrder?.assigneeType || "FieldAgent",
        assignee: data?.serviceOrder?.assignee || (null as any),
      },
      meterInfo: {
        meter: data?.serviceOrder?.installationMeter || (null as any),
      },
      extraInfo: {
        estimatedResolutionDate:
          data?.serviceOrder?.estimatedResolutionDate || "",
        priority: data?.serviceOrder?.priority || "Low",
        notes: "",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.serviceOrder, searchParams.id, open]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      hideActions={true}
      loading={loading}
      title="Assign Service Order"
      size="5xl"
      description="Provide the details to assign service order"
    >
      {data?.serviceOrder?._id && (
        <AssignInstallationServiceOrderForm form={form} />
      )}
    </Modal>
  );
}
